const onBoardingSessionStorageKey = 'pendingOnBoardingPopup';
const sessionStorageKey = 'pendingDynamicSuburbsPopup';
const merchantHostedStorageKey = 'pendingMerchantHostedLogic';

class NotificationPanelController {
    constructor($window, $rootScope, $scope, $state, sessionStorage, settings, expressService, shopperService, loginService, analytics, trolleyService, userPreferenceService, inStoreProductService, $q) {
        this.$window = $window;
        this.$scope = $scope;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.expressService = expressService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.analytics = analytics;
        this.trolleyService = trolleyService;
        this.userPreferenceService = userPreferenceService;
        this.inStoreProductService = inStoreProductService;
        this.$rootScope = $rootScope;
        this.$q = $q;
    }

    $onInit() {
        if (this.settings.CarePackage && this.settings.CarePackage.IsEnabled) {
            return;
        }

        this.shouldDisplayExpressSelectedDialog = false;
        this.shouldDisplayFulfillmentSelectorDialog = false;
        this.shouldDisplayOnboardingDialog = false;
        this.shouldHideFmsDialog = false;


        this.$scope.$on('login:success', () => {
            this.sessionStorage.set(sessionStorageKey, true);
        });

        this.$scope.$on('session:timeout', () => {
            this.shouldDisplayExpressSelectedDialog = false;
            this.shouldDisplayFulfillmentSelectorDialog = false;
            this.shouldDisplayOnboardingDialog = false;
        });

        if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
            // Feature switch for onboarding
            if (this.settings.content.enableFulfilmentSelectorModal) {
                this.sessionStorage.set(onBoardingSessionStorageKey, true);
            }
        }
        this.checkToDisplayRewardsOnboarding().then((shouldDisplayRewards) => {
            if (shouldDisplayRewards) {
                this.sessionStorage.getAndRemove(onBoardingSessionStorageKey);
                this.showOnboardingDialog();
                return;
            }
            this.showExpressSelectedDialog();
            this.shouldShowFMS = this.inStoreProductService.shouldShowFMS();

            if (this.sessionStorage.getJsonAndRemove('hasSeenRewardsOnBoardingOnHomepage')) {
                this.shouldHideFmsDialog = true;
            }

            // Show fms screen
            if ((this.sessionStorage.getAndRemove(onBoardingSessionStorageKey) || this.shouldShowFMS)
                && !this.shouldDisplayExpressSelectedDialog
                && !this.shouldHideFmsDialog) {
                switch (this.$state.current.name) {
                    case 'shop.confirmation':
                    case 'shop.myaccount.trackmyorder': {
                        break;
                    }
                    case 'shop.inspiration.parent.child': {
                        if (this.$state.params.parent !== 'meals-at-woolworths' && this.$state.params.child !== 'meal-planner') {
                            this.showFMSDialog();
                        }
                        break;
                    }
                    default: {
                        this.defaultShouldShowOnboarding();
                        break;
                    }
                }
            }
            this.$rootScope.$on('FMS:close', () => {
                if (this.sessionStorage.get(merchantHostedStorageKey)) {
                    this.$window.location.reload();
                } else {
                    this.inStoreProductService.addSavedProductToCart();
                }
            });
            if (this.sessionStorage.getAndRemove(merchantHostedStorageKey)) {
                this.inStoreProductService.addSavedProductToCart();
            }
        });
    }

    defaultShouldShowOnboarding() {
        const loginTrigger = this.sessionStorage.getAndRemove('login:trigger');
        switch (loginTrigger) {
            case 'GuestLoginToSaveAddress':
            case 'GuestLoginToFavouriteRecipe': {
                break;
            }
            default: {
                this.showFMSDialog();
                // all other cases, show FMS
                break;
            }
        }
    }

    checkToDisplayRewardsOnboarding() {
        if (this.settings.onBoarding.enableRewardsOnBoarding && !this.shopperService.IsGuest && this.settings.rewards.enableDpu) {
            const rewardsCardNumber = this.shopperService.shopper.RewardsCardNumber;

            return this.userPreferenceService.getUserPreference().then((result) => {
                const HasDoneRewardsOnboarding = result.HasDoneRewardsOnboarding;
                // if rewards card is not linked and the user has not done rewards onboarding
                if (rewardsCardNumber === '' && !HasDoneRewardsOnboarding) {
                    this.userPreferenceService.setRewardsOnboardingPreference(true);
                    return true;
                }
                return false;
            });
        }
        const deferred = this.$q.defer();
        deferred.resolve(false);
        return deferred.promise;
    }

    shouldShowfulfilmentSelector(date1, date2, callback) {
        if (this.shouldShowFMS || !date1 || !date2) {
            callback();
            return;
        }
        date1.setHours(0, 0, 0, 0);
        date2.setHours(0, 0, 0, 0);
        if (date1.getTime() !== date2.getTime()) {
            callback();
        }
    }

    showFMSDialog() {
        this.userPreferenceService.getUserPreference().then((result) => {
            const lastSeen = new Date(result.LastViewFulfilmentSelector);
            const today = new Date();
            this.shouldShowfulfilmentSelector(lastSeen, today, () => {
                this.showFulfilmentSelectorDialog();
                this.userPreferenceService.setLastViewFulfilmentMethodSelector(today);
            });
        });
    }

    showOnboardingDialog() {
        this.shouldDisplayOnboardingDialog = true;
    }

    showFulfilmentSelectorDialog() {
        this.shouldDisplayFulfillmentSelectorDialog =
            this.settings.content.enableFulfilmentSelectorModal && !this.shouldDisplayExpressSelectedDialog;
    }

    showExpressSelectedDialog() {
        this.shouldDisplayExpressSelectedDialog = this.expressService.shouldShowExpressSelectedDialog() &&
            this.$state.current.name === 'root';
    }
}

NotificationPanelController.$inject = ['$window', '$rootScope', '$scope', '$state', 'SessionStorageWrapper', 'Settings', 'ExpressService', 'ShopperService', 'LoginService', 'AnalyticsService', 'TrolleyService', 'UserPreferenceService', 'InStoreProductService', '$q'];

const notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: require('./notification-panel.component.html').trim(),
};

module.exports = {
    NotificationPanelController,
    notificationPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/notificationpanel/notification-panel.component.js